import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import CutCommand from './cutcommand';
import HtmlDataProcessor from '@ckeditor/ckeditor5-engine/src/dataprocessor/htmldataprocessor';
import viewToPlainText from '@ckeditor/ckeditor5-clipboard/src/utils/viewtoplaintext';
import CutIcon from './icons/cut.svg';
import { CkeditorConstants, removeNonNumberedCitationItems } from '../../src/utils';

const {
  event: { CITATIONS_DELETE_FROM_DOCUMENT }
} = CkeditorConstants;
const CUT = 'cut';

export default class CutUI extends Plugin {
  init() {
    const editor = this.editor;
    // Registering Cut Command
    this.editor.commands.add(CUT, new CutCommand(this.editor, CUT));
    this.editor.keystrokes.set('CTRL+X', CUT);

    editor.ui.componentFactory.add('cut', locale => {
      const view = new ButtonView(locale);
      const command = editor.commands.get('cut');
      const t = view.t;

      view.set({
        label: t('Cut'),
        withText: false,
        tooltip: true,
        icon: CutIcon,
        keystroke: 'CTRL+X'
      });

      // Callback executed once the button is clicked.
      view.on('execute', () => {
        editor.execute('cut');
      });

      view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
      this.listenTo(view, 'execute', () => editor.execute(CUT));

      // The clipboard Output cut pipeline.
      const editingview = editor.editing.view;
      const viewDocument = editingview.document;
      const modelDocument = editor.model.document;
      this._htmlDataProcessor = new HtmlDataProcessor(viewDocument);

      this.listenTo(viewDocument, 'clipboardOutput', (evt, data) => {
        if (!data.content.isEmpty) {
          data.dataTransfer.setData(
            'text/html',
            this._htmlDataProcessor.toData(data.content)
          );
          data.dataTransfer.setData(
            'text/plain',
            viewToPlainText(editor.data.htmlProcessor.domConverter, data.content)
          );

          if (data.method == 'cut') {
            const dataTransfer = data.dataTransfer;
            const content = dataTransfer.getData('text/html');
            const selection = this.editor.model.document.selection;
            if (content?.includes?.('numbered-citation') && selection?.getSelectedElement()?.name === "table") {
              data.isCut = true;
              this.editor.fire("checkNumberedCitationInTable", {
                evt,
                selectedElement: selection?.getSelectedElement(),
                data,
              });
            }
            else if (content?.includes?.('numbered-citation') && selection?.getSelectedElement()?.name !== "table") {
              data.isCut = true;
              editor.fire(CITATIONS_DELETE_FROM_DOCUMENT, { multipleRefs: { evt, data } });
              removeNonNumberedCitationItems(editor);
            } else {
              editor.model.deleteContent(modelDocument.selection);
            }
          }
        }
      });

      return view;
    });
  }
}
